module.exports = __webpack_public_path__ + "img/actualCase-6.848161b2.jpg";